/* Eaten Alive x Tesco: store finder. No dependencies. */
(function () {
  'use strict';
  var root = document.getElementById('ea-stores');
  if (!root) return;

  var input = document.getElementById('ea-stores-q');
  var chipsEl = document.getElementById('ea-stores-chips');
  var countEl = document.getElementById('ea-stores-count');
  var listEl = document.getElementById('ea-stores-list');
  var moreWrap = document.getElementById('ea-stores-more');
  var moreBtn = document.getElementById('ea-stores-more-btn');
  var PAGE = parseInt(root.getAttribute('data-page-size'), 10) || 30;

  var stores = [];
  var region = '';
  var query = '';
  var shown = PAGE;
  var timer;

  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9 ]+/g, ' ').replace(/\s+/g, ' ').trim(); }
  function plural(n) { return n + (n === 1 ? ' store' : ' stores'); }
  function safeMaps(u) { return /^https:\/\/www\.google\.com\/maps\//.test(u) ? u : ''; }

  function matches() {
    var tokens = norm(query).split(' ').filter(Boolean);
    return stores.filter(function (s) {
      if (region && s.region !== region) return false;
      for (var i = 0; i < tokens.length; i++) if (s._k.indexOf(tokens[i]) < 0) return false;
      return true;
    });
  }

  function buildChips() {
    var counts = {}, names = [];
    stores.forEach(function (s) { if (!counts[s.region]) { counts[s.region] = 0; names.push(s.region); } counts[s.region]++; });
    names.sort();
    chipsEl.textContent = '';
    [''].concat(names).forEach(function (name) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ea-stores__chip';
      b.setAttribute('data-region', name);
      b.setAttribute('aria-pressed', name === region ? 'true' : 'false');
      b.appendChild(document.createTextNode(name || 'All'));
      var sm = document.createElement('small');
      sm.textContent = '(' + (name ? counts[name] : stores.length) + ')';
      b.appendChild(sm);
      chipsEl.appendChild(b);
    });
  }

  function card(s) {
    var li = document.createElement('li');
    li.className = 'ea-stores__card';
    var h = document.createElement('h2');
    h.className = 'ea-stores__name';
    h.textContent = 'Tesco ' + s.name;
    li.appendChild(h);
    var meta = document.createElement('div');
    meta.className = 'ea-stores__meta';
    var where = document.createElement('span');
    where.textContent = s.county + ', ' + s.region;
    meta.appendChild(where);
    if (s.format) {
      var tag = document.createElement('span');
      tag.className = 'ea-stores__tag';
      tag.textContent = s.format;
      meta.appendChild(tag);
    }
    li.appendChild(meta);
    var url = safeMaps(s.mapsUrl);
    if (url) {
      var a = document.createElement('a');
      a.className = 'ea-stores__link';
      a.href = url;
      a.target = '_blank';
      a.rel = 'noopener noreferrer';
      a.textContent = 'Open in Google Maps';
      a.setAttribute('aria-label', 'Open Tesco ' + s.name + ' in Google Maps (opens in a new tab)');
      li.appendChild(a);
    }
    return li;
  }

  function render(focusFrom) {
    var res = matches();
    var slice = res.slice(0, shown);

    var msg = plural(res.length);
    if (region) msg += ' in ' + region;
    if (norm(query)) msg += ' matching “' + query.trim() + '”';
    countEl.textContent = msg;

    listEl.textContent = '';
    if (!res.length) {
      var li = document.createElement('li');
      li.className = 'ea-stores__empty';
      li.textContent = 'No stores match that search. Try a nearby town, a county, or clear the region filter.';
      listEl.appendChild(li);
    } else {
      slice.forEach(function (s) { listEl.appendChild(card(s)); });
    }

    var left = res.length - slice.length;
    moreWrap.hidden = left <= 0;
    if (left > 0) moreBtn.textContent = 'Show ' + Math.min(PAGE, left) + ' more (' + left + ' remaining)';

    if (typeof focusFrom === 'number') {
      var target = listEl.children[focusFrom];
      var link = target && target.querySelector('a');
      if (link) link.focus();
    }
  }

  function reset() { shown = PAGE; render(); }

  input.addEventListener('input', function () {
    clearTimeout(timer);
    timer = setTimeout(function () { query = input.value; reset(); }, 120);
  });
  chipsEl.addEventListener('click', function (e) {
    var b = e.target.closest('.ea-stores__chip');
    if (!b) return;
    region = b.getAttribute('data-region');
    Array.prototype.forEach.call(chipsEl.children, function (c) {
      c.setAttribute('aria-pressed', c === b ? 'true' : 'false');
    });
    reset();
  });
  moreBtn.addEventListener('click', function () {
    var from = shown;
    shown += PAGE;
    render(from);
  });

  fetch(root.getAttribute('data-src'))
    .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
    .then(function (data) {
      stores = data.map(function (s) {
        s._k = norm([s.name, s.county, s.region, s.format].join(' '));
        return s;
      });
      buildChips();
      input.disabled = false;
      render();
    })
    .catch(function () {
      countEl.textContent = 'Sorry, the store list could not load. Please refresh, or search Google Maps for “Tesco” plus your town.';
    });
})();
